import { createApp } from 'vue';
import App from './App.vue';
import VueDragscroll from 'vue3-dragscroll';
import { setupVab } from '~/library';
import { setupI18n } from '@/i18n';
import { setupStore } from '@/store';
import { setupRouter } from '@/router';
import accounting from 'accounting';
import dayjs from 'dayjs';
import { hiPrintPlugin } from 'vue-plugin-hiprint';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import ElementPlus from 'element-plus';
/**
 * @description 正式环境默认使用mock，正式项目记得注释后再打包
 */
import { baseURL, pwa } from './config';
import { isExternal } from '@/utils/validate';
import { setGlobalApp } from '~/library/plugins/modal.helper';
const app = createApp(App);
app.use(VueDragscroll);
app.use(hiPrintPlugin, '$pluginName');
hiPrintPlugin.disAutoConnect();
app.use(ElementPlus, {
    locale: zhCn
});
if (process.env.NODE_ENV === 'production' && !isExternal(baseURL)) {
    const { mockXHR } = require('@/utils/static');
    mockXHR();
}
/**
 * @description 生产环境启用组件初始化，编译，渲染和补丁性能跟踪。仅在开发模式和支持 Performance.mark API的浏览器中工作。
 */
//if (process.env.NODE_ENV === 'development') app.config.performance = true
app.config.globalProperties.$accounting = accounting;
app.config.globalProperties.$formatCurrency = (value) => {
    return accounting.formatMoney(value, {
        symbol: '¥',
        precision: 2,
        thousand: ',',
        decimal: '.',
    });
};
const formatDate = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
    if (!date)
        return '';
    return dayjs(date).format(format);
};
app.config.globalProperties.$formatDate = formatDate;
setGlobalApp(app);
if (pwa)
    require('./registerServiceWorker');
setupVab(app);
setupI18n(app);
setupStore(app);
setupRouter(app)
    .isReady()
    .then(() => app.mount('#app'));
